<script setup lang="ts">
import zhCN from '@arco-design/web-vue/es/locale/lang/zh-cn';
import enUS from '@arco-design/web-vue/es/locale/lang/en-us';

const height  = ref(0)
const  upHeight = (value:any)=>{
       height.value = value
}   
provide('height',{height,upHeight})


const lang:any =ref(localStorage.getItem("lang")||(inject('config') as any).Lang )

const locale = inject('useLang') as any
       locale.setLang(lang.value)

 const currentLang = computed(() => {
       
   const res  = locale.langState.value === 'zh-CN' ? zhCN : enUS
 
    return  res 
 })


 

</script>

<template>


      <a-config-provider :locale="currentLang">
       
          <RouterView />
       </a-config-provider>


  

</template>

